export default "__VITE_ASSET__095fcd16__"